import React, { FC } from 'react'
import text from 'styles/utility/text.module.scss'
import { BasicModal } from './index'
import { Spacer } from 'components/Utility'

type Props = {
  open: boolean
  closeModal: () => void
}

const TaxHelpModal: FC<Props> = React.memo((props) => {
  const { open, closeModal } = props

  return (
    <BasicModal open={open} closeModal={closeModal}>
      <h2 className={`${text.font_large} ${text.font_bold}`}>消費税の計算に関して</h2>
      <Spacer size={12} />
      <p>
        sacriでは、
        <span className={`${text.color_orange_main} ${text.font_bold}`}>
          消費税を小数点第一位で切り捨てした金額を税込価格
        </span>
        とさせていただいております。
      </p>
      <Spacer size={16} />
      <p>予めご理解いただきますようよろしくお願いいたします</p>
    </BasicModal>
  )
})

export default TaxHelpModal
